import { render, staticRenderFns } from "./SchematicDrawMenu.vue?vue&type=template&id=36c780f0&scoped=true"
import script from "./SchematicDrawMenu.vue?vue&type=script&lang=js"
export * from "./SchematicDrawMenu.vue?vue&type=script&lang=js"
import style0 from "./SchematicDrawMenu.vue?vue&type=style&index=0&id=36c780f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c780f0",
  null
  
)

export default component.exports